/**
 * /billing — Platform billing hub layout (PLATBILL-* umbrella).
 *
 * Renders PageHeader + tab strip (Plans / Subscriptions / MRR) + <Outlet/>
 * for child routes. Default index redirects to /billing/plans.
 *
 * Breadcrumbs: `staticData.breadcrumb` resolves under the `link-admin`
 * namespace via the augmentation shipped in Plan 02-03 (BREADCRUMB_NAMESPACES
 * allow-list). Sub-routes contribute their own breadcrumb segment.
 */
import { createFileRoute } from "@tanstack/react-router";
import { BillingHubLayout } from "../features/billing/BillingHubLayout";

export const Route = createFileRoute("/_auth/billing")({
  staticData: {
    // labelKey is namespace-prefixed (link-admin:…). RouterBreadcrumbs lists
    // the link-admin namespace in its BREADCRUMB_NAMESPACES allow-list.
    breadcrumb: { labelKey: "link-admin:billing.hub.title" },
  },
  component: BillingHubLayout,
});
